import React from 'react';
import { Box } from '@material-ui/core';
import styled from 'styled-components';

import Star from '@icons/star.svg';
import TrustedShopsSvg from '@icons/trusted-shop-badge.svg';

interface Props {
  rating: number;
  iconSize?: number;
}

const HeroRatings: React.FC<Props> = ({ rating, iconSize = 33 }) => {
  return (
    <Wrapper>
      <IconWrapper>
        <TrustedShopsSvg fill="white" height={iconSize} width={iconSize} />
      </IconWrapper>

      <ContentWrapper>
        <Stars>
          {Array(Math.ceil(rating))
            .fill(1)
            .map((_, index) => (
              <Star
                viewBox="0 0 10 10"
                height="12px"
                width="12px"
                key={index}
              />
            ))}
        </Stars>

        <RatingText>
          <RatingNumber>{rating.toFixed(1)} </RatingNumber>
          <RatingFrom>/ 5.0</RatingFrom>
        </RatingText>
      </ContentWrapper>
    </Wrapper>
  );
};

const RatingText = styled.div`
  display: flex;
  color: white;
  width: max-content;
  align-items: center;
`;

const Stars = styled.div`
  display: flex;
  align-items: center;
  align-self: flex-start;
  margin-top: 11px;
  gap: ${({ theme: { spacing } }) => spacing(0.5)}px;
`;

const ContentWrapper = styled(Box)`
  display: flex;
  align-items: center;
  justify-content: center;

  flex-direction: column;
  width: 100%;
`;

const RatingNumber = styled.div`
  font-style: normal;
  font-weight: 700;
  color: white;
  font-size: 24px;

  margin-right: 6px;
`;

const RatingFrom = styled.div`
  font-weight: 400;
  color: white;
  font-size: 12px;
  line-height: 172.5%;
  align-self: center;
`;

const IconWrapper = styled(Box)`
  display: flex;
  align-items: center;
  justify-content: center;
`;

const Wrapper = styled.div`
  display: flex;
  width: fit-content;
  align-items: center;
  justify-content: center;
  gap: ${({ theme }) => theme.spacing(2)}px;
  background-color: inherit;
`;

export default HeroRatings;
